import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'app/lib/hooks';
import {
    doSetSnowflakeUserCredentials,
    selectSetUserCredentialsError,
    selectSetUserCredentialsIsLoading
} from 'app/store/snowflakeConfiguration';
import { ButtonSize } from 'app/components/core/Button';
import { Field, Form, Submit, Yup } from 'app/components/core/Form';
import { FieldLayout } from 'app/components/core/FieldLayout';
import { Input } from 'app/components/core/Input';
import { ErrorBanner } from 'app/components/composite/ErrorBanner';
import * as styles from './UsernamePasswordForm.css';

const USER_PASSWORD_SCHEMA = Yup.object({
    user: Yup.string().required('forms:common.fields.serviceAccountUser.required'),
    password: Yup.string().required('forms:common.fields.password.required')
});

export function UsernamePasswordForm() {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const isSigningIn = useSelector(selectSetUserCredentialsIsLoading);
    const error = useSelector(selectSetUserCredentialsError);
    const onSignIn = (values) => dispatch(doSetSnowflakeUserCredentials(values));

    return (
        <Form schema={USER_PASSWORD_SCHEMA} onSubmit={onSignIn} isSubmitting={isSigningIn}>
            <FieldLayout>
                {error && (
                    <div className={styles.hasError}>
                        <ErrorBanner error={error} />
                    </div>
                )}
                <Field
                    component={Input}
                    name="user"
                    label={t('forms:common.fields.serviceAccountUser.label')}
                    placeholder={t('forms:common.fields.serviceAccountUser.placeholder')}
                />
                <Field
                    component={Input}
                    type="password"
                    name="password"
                    label={t('forms:common.fields.password.label')}
                    placeholder={t('forms:common.fields.password.placeholder')}
                />
            </FieldLayout>
            <Submit
                className={styles.submit}
                size={ButtonSize.LARGE}
                isProcessing={isSigningIn}
                fullWidth>
                {t('components:SnowflakeConnectionStatus.modal.signIn')}
            </Submit>
        </Form>
    );
}
